<template>
  <controller-section class="position-editor" title="Position" :start-visible="true">
    <div class="control-row">
      <controller field-name="width" :value="values.width" prepend-icon="arrows-left-right" @input="updateModel"></controller>
      <controller field-name="height" :value="values.height" prepend-icon="arrows-up-down" @input="updateModel"></controller>
      <controller field-name="rotate" append="º" :value="values.rotate" prepend-icon="arrows-rotate" @input="updateModel"></controller>
    </div>
    <x-y-axis-widget-controllers @update="updateModel" :values="values"></x-y-axis-widget-controllers>
    <div class="control-row centering">
      <b-button @click="horizontalCenter">
        <fa icon="fa-arrows-h"/>
      </b-button>
      <b-button @click="verticalCenter">
        <fa icon="fa-arrows-v"/>
      </b-button>
    </div>
    <slot></slot>
  </controller-section>
</template>
<script>
import consts from '../consts';
import Controller from './Controller.vue';
import ControllerSection from './ControllerSection.vue';
import XYAxisWidgetControllers from './XYAxisWidgetControllers.vue';

export default {
  name: 'PositionEditor',
  components: {
    XYAxisWidgetControllers,
    ControllerSection,
    Controller,
  },
  props: {
    values: {},
  },
  methods: {
    updateModel(field, value) {
      this.$emit('update-model', field, value);
    },
    horizontalCenter() {
      const value = Math.round((consts.BASE_SCREEN_WIDTH - this.values.width) / 2);
      this.updateModel('left', value);
    },
    verticalCenter() {
      const value = Math.round((consts.BASE_SCREEN_HEIGHT - this.values.height) / 2);
      this.updateModel('top', value);
    },
  },
};

</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.position-editor {
  .control-row {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    &:first-of-type {
      margin-top: 0px;
    }
    align-items: center;
    &.text-row {
      margin-bottom: 15px;
      &::v-deep .control input {
        text-align: right;
        direction: rtl;
      }
    }
    div {
      &:not(:last-of-type) {
        margin-right: 10px;
      }
    }
    &.centering {
      justify-content: space-around;
    }
  }
}
</style>
